// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Customer_modal__mLKvK {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.Customer_upper__Tgqa7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (max-width: 43.75em) {
  .Customer_upper__Tgqa7 {
    display: grid;
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Customer_upper__Tgqa7 {
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
  .Customer_upper__Tgqa7 > :nth-child(2) {
    grid-row: 1/2;
    grid-column: 1/3;
    justify-self: center;
  }
}
@media only screen and (max-width: 43.75em) {
  .Customer_upper__Tgqa7 > :last-child {
    grid-column: 2/3;
    justify-self: end;
  }
  .Customer_upper__btns__fvsTk {
    display: flex;
    gap: 2rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Customer_upper__btns__fvsTk {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

.Customer_customer__num__XZH7O {
  width: 18rem;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 6rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.Customer_customer__search__zY7wi {
  position: relative;
  top: -1.3rem;
}
@media only screen and (max-width: 56.25em) {
  .Customer_customer__search__zY7wi {
    top: -0.5rem;
  }
}
.Customer_customer__list__eyxOr {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Customer_customer__avatar__okqoq {
  width: 9rem;
}
.Customer_customer__avatar_container__OFK52 {
  width: 10rem;
  height: 10rem;
  border-radius: 7rem;
  border: 1px solid var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}

.Customer_table__uftGz {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Customer_table__uftGz tr {
  display: grid;
  grid-template-columns: 25% 15% 28% 15% 17%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 37.5em) {
  .Customer_table__uftGz tr {
    grid-template-columns: 1fr;
  }
}
.Customer_table__uftGz th,
.Customer_table__uftGz td {
  padding: 2.2rem 2rem;
}
.Customer_table__uftGz th {
  font-weight: 700;
}
.Customer_table__uftGz td {
  cursor: pointer;
}
.Customer_table__uftGz tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Customer_table__uftGz tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Customer_table__uftGz tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}

.Customer_minMenu__QpYGw {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Customer_gender__Rk68a {
  display: flex;
  justify-content: space-between;
}

.Customer_customerMenu__6Cd6F {
  background-color: var(--color-white);
  font-size: var(--default-font-small);
  position: absolute;
  right: 7rem;
  top: 8rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-grey);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  color: var(--color-primary);
  box-sizing: border-box;
  width: 15rem;
}
.Customer_customerMenu__6Cd6F ul {
  margin: 1.2rem 1.7rem;
}
.Customer_customerMenu__6Cd6F ul > :not(:last-child) {
  margin-bottom: 1rem;
}
.Customer_customerMenu__6Cd6F li {
  list-style: none;
  cursor: pointer;
}
.Customer_customerMenu__6Cd6F li:hover {
  color: var(--color-primary-4);
  font-weight: 700;
}

.Customer_view__BsipL {
  position: relative;
}
.Customer_view_menu__7Er\\+1 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 3rem;
  position: absolute;
  left: 20.5rem;
  top: 6rem;
}
.Customer_view_customerMenu__6leFE {
  right: -20rem;
  top: 6rem;
}
.Customer_view_content__8GZBW {
  width: 38rem;
  margin-top: 3rem;
}

.Customer_midBtn__mYKvo {
  display: flex;
  justify-content: center;
}

.Customer_checks__oeJnp {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.Customer_checks_group__SNWjE {
  align-self: center;
}

.Customer_error__JGdO1 {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Customer_checks__oeJnp {
  width: 38rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Customer/Customer.module.scss"],"names":[],"mappings":"AACA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AAAD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAAD;AACC;EAJD;IAKE,aAAA;IACA,8CAAA;IACA,SAAA;EAEA;AACF;AAAC;EAVD;IAWE,8CAAA;IACA,SAAA;EAGA;EAAD;IAEE,aAAA;IACA,gBAAA;IACA,oBAAA;EAGD;AANF;AAQE;EADD;IAEE,gBAAA;IACA,iBAAA;EAED;EAED;IAEE,aAAA;IACA,SAAA;EACD;AALF;AAME;EALD;IAME,aAAA;IACA,sBAAA;IACA,MAAA;EAGD;AACF;;AAEC;EACC,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AACF;AAEC;EACC,kBAAA;EACA,YAAA;AAAF;AACE;EAHD;IAIE,YAAA;EAED;AACF;AACC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AACF;AAEC;EACC,WAAA;AAAF;AAEE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAH;;AAOA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAJD;AAMC;EACC,aAAA;EACA,0CAAA;EACA,eAAA;EACA,mBAAA;AAJF;AAME;EAND;IAOE,0BAAA;EAHD;AACF;AAMC;;EAEC,oBAAA;AAJF;AAOC;EACC,gBAAA;AALF;AAQC;EACC,eAAA;AANF;AAUE;EACC,qBAAA;AARH;AAWE;EACC,wCAAA;EACA,qBAAA;AATH;AAWG;EACC,wCAAA;EACA,qBAAA;AATJ;;AAeA;EACC,2BAAA;EACA,eAAA;EACA,eAAA;AAZD;;AAgBA;EACC,aAAA;EACA,8BAAA;AAbD;;AAgBA;EACC,oCAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,4CAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;AAbD;AAeC;EACC,qBAAA;AAbF;AAeE;EACC,mBAAA;AAbH;AAiBC;EACC,gBAAA;EACA,eAAA;AAfF;AAiBE;EACC,6BAAA;EACA,gBAAA;AAfH;;AAqBA;EACC,kBAAA;AAlBD;AAmBC;EACC,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAjBF;AAoBC;EACC,aAAA;EACA,SAAA;AAlBF;AAqBC;EACC,YAAA;EACA,gBAAA;AAnBF;;AAwBA;EACC,aAAA;EACA,uBAAA;AArBD;;AAyBA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AAtBD;AAwBC;EACC,kBAAA;AAtBF;;AA0BA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAvBD;;AA0BA;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBD","sourcesContent":["@import '../variables/breakpoints';\n.modal {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.upper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t@media only screen and (max-width: $bp-700) {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: min-content max-content;\n\t\tgap: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: min-content max-content;\n\t\tgap: 1rem;\n\t}\n\n\t& > :nth-child(2) {\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tgrid-row: 1/2;\n\t\t\tgrid-column: 1/3;\n\t\t\tjustify-self: center;\n\t\t}\n\t}\n\n\t& > :last-child {\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-column: 2/3;\n\t\t\tjustify-self: end;\n\t\t}\n\t}\n\n\t&__btns {\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2rem;\n\t\t}\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 0;\n\t\t}\n\t}\n}\n\n.customer {\n\t&__num {\n\t\twidth: 18rem;\n\t\tbackground-color: var(--color-white);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t}\n\n\t&__search {\n\t\tposition: relative;\n\t\ttop: -1.3rem;\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\ttop: -0.5rem;\n\t\t}\n\t}\n\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__avatar {\n\t\twidth: 9rem;\n\n\t\t&_container {\n\t\t\twidth: 10rem;\n\t\t\theight: 10rem;\n\t\t\tborder-radius: 7rem;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin: 3rem 0;\n\t\t}\n\t}\n}\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 25% 15% 28% 15% 17%;\n\t\tpadding: 0 1rem;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n\n\tth,\n\ttd {\n\t\tpadding: 2.2rem 2rem;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttd {\n\t\tcursor: pointer;\n\t}\n\n\ttbody {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tborder-radius: 1.3rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.minMenu {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-size: 2rem;\n}\n//Table styles end\n\n.gender {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.customerMenu {\n\tbackground-color: var(--color-white);\n\tfont-size: var(--default-font-small);\n\tposition: absolute;\n\tright: 7rem;\n\ttop: 8rem;\n\tborder-radius: 1rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid var(--color-grey);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tcolor: var(--color-primary);\n\tbox-sizing: border-box;\n\twidth: 15rem;\n\n\tul {\n\t\tmargin: 1.2rem 1.7rem;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\tli {\n\t\tlist-style: none;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n}\n\n// View Container\n.view {\n\tposition: relative;\n\t&_menu {\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\tfont-size: 3rem;\n\t\tposition: absolute;\n\t\tleft: 20.5rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_customerMenu {\n\t\tright: -20rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_content {\n\t\twidth: 38rem;\n\t\tmargin-top: 3rem;\n\t}\n}\n\n//Add Customers\n.midBtn {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n//checkbox\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 1rem 0 2rem 0;\n\n\t&_group {\n\t\talign-self: center;\n\t}\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.checks {\n\twidth: 38rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Customer_modal__mLKvK`,
	"upper": `Customer_upper__Tgqa7`,
	"upper__btns": `Customer_upper__btns__fvsTk`,
	"customer__num": `Customer_customer__num__XZH7O`,
	"customer__search": `Customer_customer__search__zY7wi`,
	"customer__list": `Customer_customer__list__eyxOr`,
	"customer__avatar": `Customer_customer__avatar__okqoq`,
	"customer__avatar_container": `Customer_customer__avatar_container__OFK52`,
	"table": `Customer_table__uftGz`,
	"minMenu": `Customer_minMenu__QpYGw`,
	"gender": `Customer_gender__Rk68a`,
	"customerMenu": `Customer_customerMenu__6Cd6F`,
	"view": `Customer_view__BsipL`,
	"view_menu": `Customer_view_menu__7Er+1`,
	"view_customerMenu": `Customer_view_customerMenu__6leFE`,
	"view_content": `Customer_view_content__8GZBW`,
	"midBtn": `Customer_midBtn__mYKvo`,
	"checks": `Customer_checks__oeJnp`,
	"checks_group": `Customer_checks_group__SNWjE`,
	"error": `Customer_error__JGdO1`
};
export default ___CSS_LOADER_EXPORT___;
